export const _MESSAGE_TEMPLATE_FIELDS = `
  id
  active
  body
  subject
`;
